module.exports = __webpack_public_path__ + "images/stickers/pete-confused@2x.a9177cd18f31d88c66e4.png";